import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class ReferidosService {
  controller: string = "referidos/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
  ) { }

  misPuntos(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'mis-puntos', this.sesion.headers);
  }

  ajustesPuntosRecompensas(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'puntos-y-recompensas', this.sesion.headers);
  }

  getPuntos(id: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'points/' + id, this.sesion.headers);
  }

  empresasReferibles(empresa_id: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'empresas-referibles/' + empresa_id, this.sesion.headers);
  }

  canjearRecompensa(recompensa_id: number): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'canjear-recompensa', { recompensa_id }, this.sesion.headers);
  }

  canjearRecompensaAdmin(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'canjear-recompensa', data, this.sesion.headers);
  }

  addPoints(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'add-points', data, this.sesion.headers);
  }

  addReferido(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'add-referido', data, this.sesion.headers);
  }

  validarCodigoReferido(codigo_referido: string): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'validar-codigo-referido', { codigo_referido: codigo_referido }, this.sesion.headers);
  }

  puntosPorReferido(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'puntos-por-referido', this.sesion.headers);
  }
}
